import { Mail, Send, Users, Award } from 'lucide-react';

export const EMAIL_GAMES = {
  // --- MODULE 1: The Wall of Text ---
  'wall-of-text': {
    id: 'game_wall_of_text',
    
    preGameBriefing: {
        title: "The Skimmability Hack",
        script: "Executives are skimmers. If you send a 'Wall of Text,' they won't read it. Your mission: Convert this disaster of a draft into a 'BLUF' (Bottom Line Up Front) request. Speed matters—if you take too long, the moment passes.",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
    },

    failureLogic: {
        'communication_breakdown': {
            title: "Communication Breakdown",
            script: "You sent a deeply unprofessional or confusing email. In the enterprise, clarity is currency. Review the feedback and try again.",
            videoUrl: null
        }
    }
  },

  // --- MODULE 7: Modern Networking ---
  'cold-dm': {
    id: 'game_cold_dm',
    
    preGameBriefing: {
        title: "The Ask",
        script: "85% of jobs are filled via networking, but 90% of messages get ignored. Why? Because they are transactional. 'Can I have a job?' Delete. The Mission: Draft a message to an Alumnus. Goal: Get a reply.",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
    },

    failureLogic: {
        'begging': {
            title: "The Flattery Loop",
            script: "Stop. You just asked a stranger for a favor. They don't know you. The Fix: People love talking about themselves. Ask for Advice, not a Job. 'I'd love to hear your perspective on [Topic].'",
            videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
        },
        'timeout': {
            title: "Overthinking It",
            script: "You hesitated too long. A networking DM should be short, sweet, and low stakes. If you agonize over every word, you'll never hit send.",
            videoUrl: null
        }
    },

    scenario: "You found a Sr. Manager who went to your college. Connect with them.",

    template: [
      { type: 'text', content: "Hi [Name],\n\n" },
      { type: 'blank', id: 'hook' }, 
      { type: 'text', content: "\n\nI noticed you transitioned from Marketing to Product Management. " },
      { type: 'blank', id: 'ask' }, 
      { type: 'text', content: "\n\nBest,\n[You]" }
    ],

    wordBanks: {
      'hook': [
        { option: "I need a job. Please help.", score: 0, fatalError: 'begging' },
        { option: "I see we're both State U alums! Go Tigers!", score: 10, feedback: "Great. Establish the common ground immediately." },
        { option: "I looked at your profile.", score: 5, feedback: "A bit creepy/vague. Be specific." }
      ],
      'ask': [
        { option: "Can you refer me for the open Analyst role?", score: 0, fatalError: 'begging' },
        { option: "Do you have 15 mins for a virtual coffee to share your perspective?", score: 10, feedback: "Perfect. You aren't a beggar; you're a student. That's irresistible." },
        { option: "Can you look at my resume?", score: 0, fatalError: 'begging' }
      ]
    }
  },

  // --- MODULE 11: Leadership ---
  'crisis-response': {
    id: 'game_crisis_response',
    
    preGameBriefing: {
        title: "Don't Bring Problems",
        script: "Leadership isn't a title; it's a behavior. A crisis just hit. Your boss is spiraling. They don't need questions; they need answers. The Rule: Never be a 'Problem Reporter.' Be a 'Problem Solver.'",
        videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
    },

    failureLogic: {
        'homework': {
            title: "Completed Staff Work",
            script: "Wrong. You just asked 'What do you want me to do?' You gave your boss homework. The Fix: Completed Staff Work. 'I suggest we do Option A because [Reason]. I can execute by noon. Do you approve?'",
            videoUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"
        },
        'timeout': {
            title: "Crisis Escalated",
            script: "While you were drafting, the client called the CEO. Speed is a leadership trait. In a crisis, a good plan today is better than a perfect plan tomorrow.",
            videoUrl: null
        }
    },

    scenario: "The client hates the proposal. Your boss texted: 'Fix this!' Respond.",

    template: [
      { type: 'text', content: "I saw the client feedback. " },
      { type: 'blank', id: 'analysis' }, 
      { type: 'text', content: "\n\nTo fix it, " },
      { type: 'blank', id: 'solution' }, 
      { type: 'text', content: " Do you approve?" }
    ],

    wordBanks: {
      'analysis': [
        { option: "They seem mad. What should we do?", score: 0, fatalError: 'homework' },
        { option: "It looks like they misunderstood the pricing slide.", score: 10, feedback: "Good. Diagnose the issue calmly." },
        { option: "It's not my fault.", score: 0, feedback: "Defensive. Bad look." }
      ],
      'solution': [
        { option: "I can wait for your instructions.", score: 0, fatalError: 'homework' },
        { option: "I have drafted a clarification email. It's in your drafts.", score: 10, feedback: "Excellent. You did the work; they just need to click Send." },
        { option: "We should probably call them.", score: 5, feedback: "Okay, but vague. Who calls? When?" }
      ]
    }
  }
};